import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { PlatformLineageResponse, PlatformLineageView } from './types';

type FetchPlatformLineageParams = {
  view?: PlatformLineageView;
  upstreamDepth?: number;
  downstreamDepth?: number;
  includeDeleted?: boolean;
  size?: number;
};

export const fetchPlatformLineage = async ({
  view = 'service',
  upstreamDepth = 2,
  downstreamDepth = 2,
  includeDeleted = false,
  size = 50,
}: FetchPlatformLineageParams = {}): Promise<PlatformLineageResponse> => {
  const response = await openMetadataApiClient.get<PlatformLineageResponse>('/lineage/getPlatformLineage', {
    params: {
      view,
      upstreamDepth,
      downstreamDepth,
      includeDeleted,
      size,
    },
  });

  return response.data;
};
